import { filter } from 'rxjs/operators';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileService } from '../../services/file.service';
import { ErrorService } from '../../services/error/error.service';
import { EnvironmentService } from '../../services/environment.service';
import { FileDeletingEventModel, FileUploadingEventModel } from './file.models';
import { FileUpload } from 'primeng';

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss'],
})
export class FileComponent implements OnInit {
  @Input() fileType: string;
  @Input() documents: any;
  @Input() taId: string;
  @Input() uploadDisabled: boolean;
  @Input() isRequired: boolean;
  @Input() autosave: boolean = true;
  @Input() isReadonly: boolean = false;
  @Output() fileEvent = new EventEmitter();
  @Output() onFileUploading = new EventEmitter<FileUploadingEventModel>();
  @Output() onFileDeleting = new EventEmitter<FileDeletingEventModel>();

  pendingFile: File;

  constructor(
    private fileService: FileService,
    private ref: ChangeDetectorRef,
    private errorService: ErrorService,
    public environmentService: EnvironmentService
  ) {}

  ngOnInit(): void {}

  uploadHandler(event, name, form): void {
    this.pendingFile = event.files[0];
    this.onFileUploading.emit({ event: { ...event, files: [...event.files] }, name: name, taId: this.taId });

    const uploadAction = () => {
      form.clear();
      this.fileEvent.emit();
      this.ref.detectChanges();
    };

    if (!this.autosave) {
      uploadAction();
      return;
    }

    this.fileService.uploadDocuments(event, this.taId, name).subscribe(
      (response: any) => uploadAction(),
      error => {
        form.clear();
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  checkForAvailableDocuments(name: string): boolean {
    return this.fileService.checkForAvailableDocuments(this.documents, name);
  }

  downloadFile(documentId: string, fileName?: string): void {
    if (documentId && parseInt(documentId) <= 0) {
      this.downloadPendingFile();
      return;
    }

    this.fileService.readDocument(documentId).subscribe(
      (response: Blob) => {
        this.fileService.downloadDocument(response, fileName);
      },
      error => {
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  removeFile(documentId: string): void {
    this.pendingFile = null;
    this.onFileDeleting.emit({ id: documentId });

    const deleteAction = () => {
      const index = this.fileService.checkIndex(this.documents, documentId);
      if (index !== -1) {
        this.documents.splice(index, 1);
      }
      this.ref.detectChanges();
    };

    if (!this.autosave) {
      deleteAction();
      return;
    }

    this.fileService.removeFile(documentId).subscribe(
      (response: any) => deleteAction(),
      error => {
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  private downloadPendingFile() {
    var a = document.createElement('a');
    a.href = window.URL.createObjectURL(this.pendingFile);
    a.download = this.pendingFile.name;
    a.click();
  }
}
